import Vue from 'vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/styles/index.scss';
import i18n from '@/core/i18n';
import * as api from '@/core/http/api';
import { LIVE_HOSTS } from '@/core/http/config';
import state from '@/core/state';
import { installButtonLock } from '@/core/button-lock';
import { activateTemplate, resolveTemplateId } from '@/core/template-engine';
import '@/core/template-engine/asset';
import { installModules } from '@/core/module';
import { installComponents } from '@/core/components';
import { installIcons } from '@/ui/icons';
import createRouter from '@/core/router';
import sharedModules from '@/modules';
import App from '@/core/App.vue';

Vue.config.productionTip = false;
installIcons();

Vue.prototype.$api = api;
Vue.prototype.$sharedState = state;

installButtonLock();

if (LIVE_HOSTS.includes(window.location.hostname)) {
    document.addEventListener('contextmenu', e => e.preventDefault());
    document.addEventListener('keydown', e => {
        if (e.key === 'F12') e.preventDefault();
        if ((e.ctrlKey || e.metaKey) && e.shiftKey && ['I', 'J', 'C'].includes(e.key.toUpperCase())) e.preventDefault();
        if ((e.ctrlKey || e.metaKey) && e.key.toUpperCase() === 'U') e.preventDefault();
    });
}

export default async function bootstrap() {
    const template = activateTemplate(resolveTemplateId());
    await template.theme();
    installModules(template, sharedModules);
    installComponents();

    new Vue({
        router: createRouter(),
        i18n,
        render: h => h(App)
    }).$mount('#app');
}
